import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { IComment } from '@app/api/interfaces/comment.interface';
import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';

export enum FpCorrelationCommentsActionType {
  GetData = 'GetData',
  GetDataSuccesses = 'GetDataSuccesses',
  SaveComment = 'SaveComment',
  SaveCommentSuccess = 'SaveCommentSuccess',
  SaveCommentError = 'SaveCommentError',
}

export interface FpCorrelationCommentsActionGetData {
  type: FpCorrelationCommentsActionType.GetData;
  date: string | null;
  popupMainData: IFpCorrelationData | null;
}

export interface FpCorrelationCommentsActionGetDataSuccesses {
  type: FpCorrelationCommentsActionType.GetDataSuccesses;
  date: string | null;
  data: IFpCorrelationData | null;
}

export interface FpCorrelationCommentsActionSaveComment {
  type: FpCorrelationCommentsActionType.SaveComment;
  content: string;
}

export interface FpCorrelationCommentsActionSaveCommentSuccess {
  type: FpCorrelationCommentsActionType.SaveCommentSuccess;
  comment: IComment;
}

export interface FpCorrelationCommentsActionSaveCommentError {
  type: FpCorrelationCommentsActionType.SaveCommentError;
  error: IApiBaseErrorResponse;
}

export type FpCorrelationCommentsActions =
  | FpCorrelationCommentsActionGetData
  | FpCorrelationCommentsActionGetDataSuccesses
  | FpCorrelationCommentsActionSaveComment
  | FpCorrelationCommentsActionSaveCommentSuccess
  | FpCorrelationCommentsActionSaveCommentError;
